/**
 * Admin Worker Health API Service
 */

import { apiClient } from "./apiClient";

export interface StreamHealthStatus {
  stream_type: string;
  stream_key: string;
  consumer_group: string;
  pending_count: number;
  stream_length: number;
  last_processed: string | null;
  last_processed_timestamp: number | null;
  age_seconds: number | null;
  is_stalled: boolean;
  recovery_attempts: number;
  last_alert_time: number | null;
}

export interface WorkerHealthResponse {
  entry: StreamHealthStatus;
  exit: StreamHealthStatus;
  monitor: StreamHealthStatus;
  timestamp: number;
}

/**
 * Get worker health status
 */
export async function getWorkerHealth(): Promise<WorkerHealthResponse> {
  const response = await apiClient.get<WorkerHealthResponse>(
    "/admin/worker-health",
    {
      timeout: 15000, // 15 second timeout to prevent hanging
    }
  );
  return response.data;
}

